import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import MKTypography from "components/MKTypography";
import { useTheme } from "@emotion/react";
/**
 * RecaptchaBadge Component
 * Displays the required reCAPTCHA branding with links to Google's Privacy Policy and Terms of Service
 * This replaces the default floating badge which is hidden via CSS
 *
 * @param {Object} props
 * @param {string} props.variant - Color variant: "light" or "dark"
 * @returns {JSX.Element}
 */
const RecaptchaBadge = ({ variant = "light" }) => {
  const theme = useTheme();
  const textColor = variant === "dark" ? theme.palette.white.main : theme.palette.grey[600];
  const linkColor = variant === "dark" ? theme.palette.accent.main : theme.palette.secondary.main;

  return (
    <Box
      sx={{
        marginTop: "1rem",
        fontSize: "10px",
        lineHeight: "14px",
        color: textColor,
      }}
      role="contentinfo"
      aria-label="reCAPTCHA information"
    >
      <MKTypography
        component="span"
        variant="caption"
        sx={{
          fontSize: "10px",
          color: textColor,
        }}
      >
        This site is protected by reCAPTCHA and the Google{" "}
        <MKTypography
          component="a"
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          sx={{
            fontSize: "10px",
            color: linkColor,
            textDecoration: "underline",
            "&:hover": {
              textDecoration: "none",
            },
          }}
        >
          Privacy Policy
        </MKTypography>{" "}
        and{" "}
        <MKTypography
          component="a"
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          sx={{
            fontSize: "10px",
            color: linkColor,
            textDecoration: "underline",
            "&:hover": {
              textDecoration: "none",
            },
          }}
        >
          Terms of Service
        </MKTypography>{" "}
        apply.
      </MKTypography>
    </Box>
  );
};

RecaptchaBadge.propTypes = {
  variant: PropTypes.oneOf(["light", "dark"]),
};

export default RecaptchaBadge;
